export default __webpack_public_path__ + "static/media/gd.33a919de.svg";